import { useMemo } from 'react'

export const useImpersonationSession = () => {
  const activeImpersonationSession =
    typeof window !== 'undefined' ? localStorage.getItem('activeImpersonationSession') : null

  return useMemo(() => {
    if (!activeImpersonationSession) {
      return {
        isImpersonating: false,
        impersonationInfo: null,
      }
    }

    try {
      const session = JSON.parse(activeImpersonationSession)
      return {
        isImpersonating: true,
        impersonationInfo: {
          sessionId: session.sessionId,
          adminUser: session.adminUser,
          staffUser: session.staffUser,
          startedAt: session.startedAt,
        },
      }
    } catch {
      return {
        isImpersonating: false,
        impersonationInfo: null,
      }
    }
  }, [activeImpersonationSession])
}
